import React from 'react';
import '../template-file-css/document-file-template.css';


export const GFIT_LaboratoryRequestForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GFIT_LaboratoryRequestForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <h1> <center> Laboratory Request Form </center> </h1>
                </p>

                <p className='w-750'> <center> 160 Clairemont Ave. Suite 265  Decatur, GA 30030 </center>
                </p>
                <p className='w-750'> <center> Office: 678-951-0632    Fax:  678-904-2454 </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Individual Name: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> DOB: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <input type='text' id='txtIndividualName' name='txtIndividualName' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDob' name='txtDob' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Diagnosis Code: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Description: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <input type='text' id='txtDiagnosisCode' name='txtDiagnosisCode' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtDescription' name='txtDescription' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Please obtain the following laboratory studies: </span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbCbc' name='cbCbc' className='add-only' value='CBC' /> CBC <br /> </td>
                        <td className='w-375'> <input type='text' id='txtReferringAgencyName' name='txtReferringAgencyName' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'> &nbsp; </td>
                        <td className='w-680'>
                            <input type='radio' id='rb_No1' name='rbYes1' className='add-only' value='No' /> With Differential &nbsp;
                            <input type='radio' id='rb_No1' name='rbYes1' className='add-only' value='No' /> Without Differential
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbComprehensiveMetabolicPanel' name='cbComprehensiveMetabolicPanel' className='add-only' value='Comprehensive Metabolic Panel' /> Comprehensive Metabolic Panel </td>
                        <td className='w-375'> <input type='text' id='txtReferringAgencyName' name='txtReferringAgencyName' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbTsh' name='cbTsh' className='add-only' value='TSH' /> TSH </td>
                        <td className='w-375'> <input type='text' id='txtTsh' name='txtTsh' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbLithiumLevel' name='cbLithiumLevel' className='add-only' value='Lithium Level' /> Lithium Level </td>
                        <td className='w-375'> <input type='text' id='txtLithiumLevel' name='txtLithiumLevel' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbTegretolLevel' name='cbTegretolLevel' className='add-only' value='Tegretol Level' /> Tegretol Level </td>
                        <td className='w-375'> <input type='text' id='txtTegretolLevel' name='txtTegretolLevel' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbValproicAcidLevel' name='cbValproicAcidLevel' className='add-only' value='Valproic Acid Level' /> Valproic Acid Level </td>
                        <td className='w-375'> <input type='text' id='txtValproicAcidLevel' name='txtValproicAcidLevel' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbFastingLipidProfile' name='cbFastingLipidProfile' className='add-only' value='Fasting Lipid Profile' /> Fasting Lipid Profile </td>
                        <td className='w-375'> <input type='text' id='txtFastingLipidProfile' name='txtFastingLipidProfile' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbHgbaC ' name='cbHgbaC' className='add-only' value='HgbA, C' /> HgbA, C </td>
                        <td className='w-375'> <input type='text' id='txtHgbaC' name='txtHgbaC' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbUrinalysis' name='cbUrinalysis' className='add-only' value='Urinalysis' /> Urinalysis </td>
                        <td className='w-375'> <input type='text' id='txtUrinalysis' name='txtUrinalysis' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbProlactinLevel' name='cbProlactinLevel' className='add-only' value='Prolactin Level' /> Prolactin Level </td>
                        <td className='w-375'> <input type='text' id='txtProlactinLevel' name='txtProlactinLevel' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbUrineDrugScreen' name='cbUrineDrugScreen' className='add-only' value='Urine Drug Screen' /> Urine Drug Screen </td>
                        <td className='w-375'> <input type='text' id='txtUrineDrugScreen' name='txtUrineDrugScreen' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    Please fax results and/or mail a hard copy to Georgia Families in Transition at the above address.
                    <br />
                    Thank You,
                </p>


                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> Nurse Practitioner Printed Name </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Date: </span> </td>
                    </tr> 
                    <tr>
                        <td className='w-500'> <input type='text' id='txtNursePractitionerPrintedName' name='txtNursePractitionerPrintedName' className='add-only' /> </td>
                        <td className='w-250'> <input type='Date' id='txtDate' name='txtDate' className='add-only' /> </td>
                    </tr> 
                </table>
                {/* <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className=' w-500'> Nurse Practitioner Signature </td>
                        <td className='w-250'> Date </td>
                    </tr>

                </table> */}





            </div>
        </form>

    )
}